module.exports = __webpack_public_path__ + "static/media/screen-lumen.3e1076f0.png";